import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/service/apps/service-form",
  "description": "Запишитесь на сервис к официальном дилеру ŠKODA онлайн! Заполинте форму заявки на официальном сайте компании «ŠKODA AUTO Россия».",
  "huggerTemplate": "default",
  "keywords": "Заявка на запись на сервис",
  "name": "form-service",
  "title": "Запись на сервис ŠKODA"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CustomIFrame = makeShortcode("CustomIFrame");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <CustomIFrame title="Заявка на запись на сервис" src="https://service-entry.skoda-avto.ru/service?showInLayer=true" height="850px" width="0" style={{
      minWidth: '100%'
    }} mdxType="CustomIFrame" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      